"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BenefitsCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _ProductTitle = _interopRequireDefault(require("./blocks/benefits/ProductTitle"));
var _ProductPrice = _interopRequireDefault(require("./blocks/benefits/ProductPrice"));
var _DividerBottomSpace = _interopRequireDefault(require("./blocks/DividerBottomSpace"));
var _BenefitsIconsWithTitles = _interopRequireDefault(require("./blocks/benefits/BenefitsIconsWithTitles"));
var _r10CommonComponents = require("r10-common-components");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _functions = require("../helpers/functions");
var _useConfig3 = _interopRequireDefault(require("../hooks/useConfig"));
var _jsonpathPlus = require("jsonpath-plus");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n"])));
function BenefitsCard(_ref) {
  var campaignDetails = _ref.campaignDetails;
  var t = (0, _useTranslation.default)();
  var _useConfig = (0, _useConfig3.default)(),
    _useConfig$jsonPaths = _useConfig.jsonPaths,
    _useConfig$jsonPaths2 = _useConfig$jsonPaths === void 0 ? {} : _useConfig$jsonPaths,
    priceValuePath = _useConfig$jsonPaths2.priceValuePath,
    catalogPriceValuePath = _useConfig$jsonPaths2.catalogPriceValuePath,
    discountPercentagePath = _useConfig$jsonPaths2.discountPercentagePath,
    priceUnitPath = _useConfig$jsonPaths2.priceUnitPath,
    productNamePath = _useConfig$jsonPaths2.productNamePath,
    _useConfig$jsonPaths3 = _useConfig$jsonPaths2.benefits,
    _useConfig$jsonPaths4 = _useConfig$jsonPaths3 === void 0 ? {} : _useConfig$jsonPaths3,
    smsAllowancePath = _useConfig$jsonPaths4.smsAllowancePath,
    dataAllowancePath = _useConfig$jsonPaths4.dataAllowancePath,
    voiceAllowancePath = _useConfig$jsonPaths4.voiceAllowancePath,
    voiceToVFAllowancePath = _useConfig$jsonPaths4.voiceToVFAllowancePath,
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    unlimitedValue = _useConfig$widgetCust2.unlimitedValue;
  var _JSONPath = (0, _jsonpathPlus.JSONPath)({
      path: productNamePath,
      json: campaignDetails[0]
    }),
    _JSONPath2 = _slicedToArray(_JSONPath, 1),
    productName = _JSONPath2[0];
  var _JSONPath3 = (0, _jsonpathPlus.JSONPath)({
      path: priceValuePath,
      json: campaignDetails[0]
    }),
    _JSONPath4 = _slicedToArray(_JSONPath3, 1),
    price = _JSONPath4[0];
  var _JSONPath5 = (0, _jsonpathPlus.JSONPath)({
      path: catalogPriceValuePath,
      json: campaignDetails[0]
    }),
    _JSONPath6 = _slicedToArray(_JSONPath5, 1),
    catalogPrice = _JSONPath6[0];
  var _JSONPath7 = (0, _jsonpathPlus.JSONPath)({
      path: discountPercentagePath,
      json: campaignDetails[0]
    }),
    _JSONPath8 = _slicedToArray(_JSONPath7, 1),
    discountPercentage = _JSONPath8[0];
  var _JSONPath9 = (0, _jsonpathPlus.JSONPath)({
      path: priceUnitPath,
      json: campaignDetails[0]
    }),
    _JSONPath10 = _slicedToArray(_JSONPath9, 1),
    priceUnit = _JSONPath10[0];
  var _JSONPath11 = (0, _jsonpathPlus.JSONPath)({
      path: dataAllowancePath,
      json: campaignDetails[0]
    }),
    _JSONPath12 = _slicedToArray(_JSONPath11, 1),
    data = _JSONPath12[0];
  var _JSONPath13 = (0, _jsonpathPlus.JSONPath)({
      path: voiceAllowancePath,
      json: campaignDetails[0]
    }),
    _JSONPath14 = _slicedToArray(_JSONPath13, 1),
    voice = _JSONPath14[0];
  var _JSONPath15 = (0, _jsonpathPlus.JSONPath)({
      path: voiceToVFAllowancePath,
      json: campaignDetails[0]
    }),
    _JSONPath16 = _slicedToArray(_JSONPath15, 1),
    voiceVf = _JSONPath16[0];
  var _JSONPath17 = (0, _jsonpathPlus.JSONPath)({
      path: smsAllowancePath,
      json: campaignDetails[0]
    }),
    _JSONPath18 = _slicedToArray(_JSONPath17, 1),
    sms = _JSONPath18[0];
  var benefits = (0, _functions.getBenefitsIconsWithTitles)(t, data, voice, voiceVf, sms, unlimitedValue);
  var _useConfig2 = (0, _useConfig3.default)(),
    hidePerMonth = _useConfig2.hidePerMonth;
  var finalPriceProcessed = _r10CommonComponents.utils.formatMoney(price !== null && price !== void 0 ? price : '', priceUnit !== null && priceUnit !== void 0 ? priceUnit : '');
  var catalogPriceProcessed = _r10CommonComponents.utils.formatMoney(catalogPrice !== null && catalogPrice !== void 0 ? catalogPrice : '', priceUnit !== null && priceUnit !== void 0 ? priceUnit : '');
  var finalPriceWithSymbol = "".concat(finalPriceProcessed.money).concat(finalPriceProcessed.currencySymbol);

  // eslint-disable-next-line max-len
  var catalogPriceWithSymbol = "".concat(catalogPriceProcessed.money).concat(catalogPriceProcessed.currencySymbol);
  var perMonthText = !hidePerMonth ? t('per_month') : '';
  var processedDiscountPercentage = discountPercentage ? "".concat(discountPercentage, "% ").concat(t('discount_today')) : t('discount_today');
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: processedDiscountPercentage,
    appearance: "secondary",
    elevation: true,
    dataSelectorPrefix: "pega-details-benefits-card"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(FlexDiv, null, productName && /*#__PURE__*/_react.default.createElement(_ProductTitle.default, {
    productName: productName,
    testCase: "benefits"
  }), !finalPriceProcessed.error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !catalogPriceProcessed.error ? /*#__PURE__*/_react.default.createElement(_ProductPrice.default, {
    catalogPriceWithSymbol: catalogPriceWithSymbol,
    finalPriceWithSymbol: finalPriceWithSymbol,
    perMonthText: perMonthText
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 4
  }, finalPriceWithSymbol, " ", perMonthText)))), /*#__PURE__*/_react.default.createElement(_DividerBottomSpace.default, {
    space: 3,
    appearance: "secondary"
  }), /*#__PURE__*/_react.default.createElement(_BenefitsIconsWithTitles.default, {
    benefits: benefits,
    testCase: "benefits"
  }));
}
BenefitsCard.propTypes = {
  campaignDetails: _propTypes.default.any
};